import { EPaymentMethod } from "@rentiohq/shared-frontend/dist/types/payment.types";
import { Route } from "react-router-dom";
import Payments from "../Payments";
import { AddBankAccount } from "./components/AddBankAccount";
import { BankWireOverview } from "./components/BankWireOverview";
import { IbanAccountSelect } from "./components/IbanAccountSelect";
import { PaymentDetail } from "./components/PaymentDetail";
import { PaymentLimit } from "./components/PaymentLimit";
import { PaymentMethodSelect } from "./components/PaymentMethodSelect";
import { PaymentStatus } from "./components/PaymentStatus";

export const getPaymentsScene = () => {
  return (
    <>
      <Route path="payments" element={<Payments />} />
      <Route path="payment">
        <Route path=":paymentRequestId" element={<PaymentDetail />} />
        <Route path={":paymentRequestId/status"} element={<PaymentStatus />} />
        <Route
          path=":paymentRequestId/payment-method"
          element={<PaymentMethodSelect />}
        />
        <Route
          path=":paymentRequestId/payment-method/mangopay"
          element={<IbanAccountSelect />}
        />
        <Route
          path={":paymentRequestId/payment-method/bank-wire"}
          element={<BankWireOverview paymentMethod={EPaymentMethod.BankWire} />}
        />
        <Route
          path=":paymentRequestId/payment-method/ibanisation"
          element={
            <BankWireOverview paymentMethod={EPaymentMethod.Ibanisation} />
          }
        />
        <Route
          path={":paymentRequestId/payment-method/mangopay/add-iban"}
          element={<AddBankAccount />}
        />

        <Route
          path={":paymentRequestId/payment-method/:paymentMethod/payment-limit"}
          element={<PaymentLimit />}
        />
      </Route>
    </>
  );
};
